module.exports = __webpack_public_path__ + "img/ng.cb2bc01.png";


//////////////////
// WEBPACK FOOTER
// ./static/ng.png
// module id = JVll
// module chunks = 22